<template>
  <div class="row g-4">
    <div class="col-12 mb-3">
      <router-link to="/work/buckets" class="btn btn-secondary btn-no-r">
        <span><BaseIcon name="active" /> {{ $t("work.dashboard") }}</span>
      </router-link>
      <router-link
        to="/work/tracking"
        class="btn btn-no-l btn-no-r btn-secondary"
      >
        <span><BaseIcon name="timer" /> {{ $t("work.timeTracking") }}</span>
      </router-link>
      <router-link
        to="/work/tracking/performance"
        class="btn btn-no-l btn-primary"
      >
        <span><BaseIcon name="timer" /> {{ $t("work.timeTracking") }}</span>
      </router-link>
    </div>
    <div class="col-12 row">
      <div
        v-for="category in data"
        :key="category.event_name"
        class="col-lg-4 mb-4"
      >
        <div class="card p-3 h-100">
          <div class="category-title">{{ category.event_name }}</div>
          <div class="category-metric">
            {{ $t("work.average") }}: {{ formatDuration(category.overall_avg) }}
          </div>
          <div class="graph-wrapper">
            <div class="graph-scale">
              <div
                v-for="user in category.users"
                :key="user.user_id"
                class="graph-marker"
                :style="{
                  left: calculatePosition(user.avg_duration, category) + '%',
                }"
              >
                <div
                  class="graph-dot"
                  :class="getDotColor(user.avg_duration, category)"
                ></div>
                <div class="graph-label">
                  {{ user.name }} {{ formatDuration(user.avg_duration) }}
                </div>
              </div>
            </div>
            <div class="scale-labels">
              <span>{{ $t("work.fast") }}</span>
              <span>{{ $t("work.slow") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import date from "../../../modules/date";
import http from "@/modules/http";
import BaseIcon from "../../../components/icons/BaseIcon.vue";

export default {
  name: "UserPerformance",
  components: { BaseIcon },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      const url = this.id ? "/work/timing/" + this.id : "/work/timing";
      http.fetch(url).then((data) => {
        this.data = data;
      });
    },
    formatDate(val) {
      return date.format(val, false, false);
    },
    formatDuration(seconds) {
      if (seconds < 60) {
        return Math.round(seconds * 10) / 10 + "s";
      }
      const minutes = Math.round((seconds / 60) * 10) / 10;
      return minutes + "m";
    },
    calculatePosition(val, category) {
      const avg = category.overall_avg;
      if (avg === 0) return 50;

      // Map value relative to average.
      // 0.5 * avg -> 0% (Fast)
      // avg       -> 50% (Average)
      // 1.5 * avg -> 100% (Slow)
      let position = (val / avg) * 50;

      if (position < 5) position = 5;
      if (position > 95) position = 95;

      return position;
    },
    getDotColor(val, category) {
      const avg = category.overall_avg;
      if (val < avg * 0.9) return "dot-green";
      if (val > avg * 1.3) return "dot-red";
      if (val > avg * 1.1) return "dot-orange";
      return "dot-blue";
    },
  },
};
</script>
<style scoped>
.category-title {
  font-weight: 700;
  font-size: 1.2rem;
}

.category-metric {
  font-size: 0.9rem;
  color: #6b7280;
}

.graph-wrapper {
  margin-top: 2rem;
  margin-bottom: 2em;
}

.graph-scale {
  position: relative;
  height: 14px;
  background: linear-gradient(90deg, #16a34a, #eab308, #dc2626);
  border-radius: 10px;
}

.graph-marker {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.graph-dot {
  margin: 0 auto;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dot-green {
  background: #16a34a;
}
.dot-blue {
  background: #6366f1;
}
.dot-orange {
  background: #f59e0b;
}
.dot-red {
  background: #dc2626;
}

.graph-label {
  font-size: 0.75rem;
  margin-top: 8px;
  max-width: 5em;
  position: absolute;
  background: #fff;
}

.scale-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  margin-top: 0.8rem;
  color: #6b7280;
}
</style>
